<template>
    <div class="appointment">
        <page-title pageName="场地预约"></page-title>
        <Space></Space>
        <div class="topBtns">
            <div class="searchKey">
                <el-input v-model="searchKey" placeholder="请输入项目名称/预约者"></el-input>
            </div>
            <div style="margin-left:15px">
                业务类型:
                <el-select v-model="businessType" clearable placeholder="请选择">
                    <el-option
                    v-for="item in businessTypeList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div v-if="isadmin" style="margin-left:15px">
              <el-select v-model="tradeOrgId" clearable placeholder="请选择">
                <el-option
                    v-for="item in tradeOrgList"
                    :key="item.id"
                    :label="item.orgName"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            
            <el-button @click="getSearch">查询</el-button>
            <el-button type="primary" @click="toRefresh">刷新</el-button>
            <el-button type="primary" @click="toAdd">新增</el-button>
        </div>
        <Space></Space>

        <el-table
                :data="tableData"
                border
                stripe
                :height="tableMaxHeight"
                style="width: 100%;margin-top:16px;"
                @filter-change="filterChange" @sort-change="sortChange"
                >
            <el-table-column
                    prop=""
                    label=""
                    type="index"
                    header-align="center"
                    align="center"
                    fixed
                    width="44">
            </el-table-column>
            <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    fixed
                    width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.historyid >=0||!scope.row.canModify" @click="toDetail(scope.row.id)" style="font-size: 20px;cursor:pointer;margin: 0 5px;"  class="el-icon-view"></span>
                    <span v-if="scope.row.historyid <0&& scope.row.canModify" @click="toExit(scope.row.id)" style="font-size: 20px;cursor:pointer;margin: 0 5px;"  class="el-icon-edit"></span>
                    <span v-if="scope.row.historyid <0&& scope.row.canModify" @click="toDelete(scope.row.id)" style="font-size: 20px;cursor:pointer;margin: 0 5px;" class="el-icon-delete"></span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="historyid"
                    label="受理状态"
                    header-align="center"
                    align="center"
                    column-key="historyid"
                    fixed
                    width="125">
                <template slot-scope="scope">
                    <span
                        class="status"
                        :class="scope.row.historyid==0?'status-done':null">
                    {{scope.row.historyid < 0 ?(!scope.row.active?'被退回': scope.row.taskDesc?scope.row.taskDesc:'处理中'):"审核通过"}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="applyTime"
                    label="预约时间"
                    header-align="center"
                    align="center"
                    fixed
                    :sortable='true'
                    width="155">
            </el-table-column>

            <el-table-column
                    prop="applyLinksNames"
                    label="场地用途分类"
                    header-align="center"
                    align="center"
                    width="155">
                    <template slot-scope="scope">
                        <el-tag  v-for="(item,i) in scope.row.applyLinksNames?.split(',')" :key="i" :type="(item=='开标' || item=='评标') ? 'success' : 'warning'">{{ item }}</el-tag>
                    </template>
            </el-table-column>
            <el-table-column
                    align="left"
                    show-overflow-tooltip
                    fixed
                    header-align="center"
                    width="180">
                    <template slot="header" slot-scope="scope">
                        预约场地 <el-popover
                            placement="bottom"
                            width="300"
                            trigger="click">
                            <div style="padding: 12px;">
                                <el-input name="fieldNameSearch" v-model="fieldNameSearch" placeholder="请输入预约场地" size="small"  slot="reference"></el-input>
                                <div style="text-align: right; margin-top: 8px">
                                    <el-button type="text" @click="handleFieldNameSearch">查询</el-button>
                                    <el-button type="text" @click="handleFieldNameReset">重置</el-button>
                                </div>
                            </div>
                            <i class="el-icon-search" slot="reference"></i>
                        </el-popover>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.fieldName}}</span>
                    </template>
            </el-table-column>
            <el-table-column
                    prop="regionName"
                    label="所属区域"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.regionName?.split('/')[2] ? 'success':''" >{{ scope.row.regionName?.split('/')[2] }}</el-tag>
                    </template>
            </el-table-column>
            <el-table-column
                    prop="applicant"
                    label="预约者"
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    width="180">
            </el-table-column>
            <el-table-column
                prop="businessName"
                header-align="center"
                align="left"
                show-overflow-tooltip
                width="150"
                label="项目名称/用途">
            </el-table-column>
            <el-table-column
                    prop="appointmentType"
                    label="预约类型"
                    header-align="center"
                    align="center"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="businessTypeName"
                    label="业务类型"
                    header-align="center"
                    align="center"
                    width="120">
                    <template slot-scope="scope">
                        <el-tag :class="scope.row.businessTypeName=='政府采购' ? 'businessTypeTag':''" >{{ scope.row.businessTypeName }}</el-tag>
                    </template>
            </el-table-column>
            <el-table-column
                    prop="businessClassfyName"
                    column-key="businessClassfyName"
                    label="业务细分类"
                    header-align="center"
                    align="center"
                    :filters="[
                        {text:'资格后审',value:1},
                        {text:'资格预审',value:2},
                        {text:'定标',value:3},
                        {text:'其他',value:9},
                    ]"
                    :filtered-value="businessClassList"
                    width="120">
            </el-table-column>
            <el-table-column
                prop="version"
                label="当前版本"
                header-align="center"
                align="center"
                width="80">
            </el-table-column>
            <el-table-column
                    prop="updateUser"
                    label="修改者"
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="updateTime"
                    label="修改时间"
                    header-align="center"
                    align="center"
                    :sortable='true'
                    width="155">
            </el-table-column>
            <el-table-column
                    prop="createUser"
                    label="创建者"
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="创建时间"
                    header-align="center"
                    align="center"
                    :sortable='true'
                    width="155">
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :page-size="pageSize"
                :total="totalNumber">
        </el-pagination>
    </div>
</template>
<script>
    import {tabsRefreshCurrentHandle} from '@/utils/routeTab'
    import {mapState} from 'vuex'
    import Space from '@/components/space.vue'
    import pageTitle from '@/components/pageTitle.vue'
    export default {
        components:{
            Space,
            pageTitle
        },
        data(){
            return {
                visible:false,
                searchKey:'',
                businessType:'',
                tradeOrgId:'',
                fieldNameSearch:'',
                statusFilterList:[],
                businessClassList:[],
                sortCheckObj:{},
                tableData:[],
                totalNumber:0,
                currentPage:1,
                rows:10,
                pageSize:10,
                tableMaxHeight:document.documentElement.clientHeight - 340
            }
        },
        activated(){
            this.$store.dispatch('region/getBusinessTypeList');
            this.$store.dispatch('region/getTradeOrgList');
            this.getTableData();
        },
        computed: {
            ...mapState({
                businessTypeList: (state) => state.region.businessTypeList,
                tradeOrgList: (state) => state.region.tradeOrgList,
                isadmin: (state) => state.user.supperAdmin,
            })
        },
        methods:{
            filterChange(filter) {
                this.statusFilterList=filter.historyid;
                this.businessClassList=filter.businessClassfyName;
                this.getTableData();
            },
            sortChange(arg){
                this.sortCheckObj=arg;
                this.getTableData();
            },
            handleFieldNameSearch(){
                this.visible=false;
                this.getTableData();
            },
            handleFieldNameReset(){
                this.visible=false;
                this.fieldNameSearch='';
                this.getTableData();
            },
            getSearch(){
                this.getTableData();
            },
            handleSizeChange(val){
                console.log(val)
                this.rows = val;
                this.getTableData();
            },
            handleCurrentChange(val){
                console.log(val)
                this.currentPage = val;
                this.getTableData();
            },
            formatterSort(obj){
                let str = '';
                if(obj.prop=='applyTime') str+='b.apply_time ';
                if(obj.prop=='updateTime') str+='a.update_time ';
                if(obj.prop=='createTime') str+='a.create_time ';

                if(obj.order=='ascending') str+='asc';
                if(obj.order=='descending') str+='desc';
                return str;
            },
            getTableData(){
                this.$http.post('/field/applymanage/list',{
                    "filter": {
                        fieldName:this.fieldNameSearch,
                        statusFilterList:this.statusFilterList,
                        businessClassList:this.businessClassList,
                        businessType:this.businessType,
                        tradeOrgId:this.tradeOrgId,
                        orderBy: this.sortCheckObj?.order ? this.formatterSort(this.sortCheckObj) :"a.create_time desc",
                    },
                    "page": this.currentPage,
                    "rows": this.rows,
                    "searchKey": this.searchKey
                }).then(res=>{
                    console.log('预约tableData',res.data.rows)
                    this.tableData = res.data.rows;
                    this.totalNumber = res.data.total;
                })
            },
            toAdd(){
                this.$router.push('/appointmentExit');
            },
            toDetail(id){
                this.tabsCloseHandle('appointmentDetail');
                this.$router.push({name:'appointmentDetail',query:{id:id}});
            },
            toExit(id){
                this.tabsCloseHandle('appointmentExit');
                this.$router.push({name:'appointmentExit',query:{id:id}});
            },
            toDelete(id){
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post('/field/applymanage/delete',{
                        id:id
                    }).then(res=>{
                        console.log('delete',res)
                        if(res.data.code == 1){
                            this.$message.success(res.data.msg);
                            this.toRefresh();
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            toRefresh(){
                this.getSearch();
            },
        },
    }
</script>
<style lang="scss" scoped>

.appointment{
    padding: 0 16px 16px;
    .topBtns{
        // height: 50px;
        display: flex;
        margin:16px 0;
        .searchKey{
            width: 200px;
        }
        .el-button--medium{
            height: 36px;
            margin: 0 0 0 10px;
        }
    }

    .businessTypeTag{
        background: rgb(247,238,253);
        color: purple;
        border: #d3e1fb 1px solid;
    }

    .status {
            padding-left: 15px;
			position: relative;
			&:before{
				content: '';
				width: 6px;
				height: 6px;
				border-radius: 50%;
				position: absolute;
				left: 0;
				top: 50%;
				transform: translate(0,-50%);
				background: #FF0000;
			}
            &.status-done {
                &:before {
                    background: #52C41A;
                }
            }
        }
}
</style>